import React, { useState, useEffect, Suspense } from "react";
import "./blogs.css";
import { Link, useNavigate } from "react-router-dom";
import BlogsService from "../Services/blogs.service";

import { Gallery } from "react-grid-gallery";

import AOS from "aos";
import "aos/dist/aos.css";

const Blogs = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState({});

  const [galleryImgs, setGalleryImgs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  const fetchBlogs = () => {
    BlogsService.fetchBlogsData()
      .then((resp) => {
        if (resp.data) {
          setBlogs(resp.data);
          setGalleryImgs(
            resp.data.map((item) => ({
              src: `https://fidusindia.in/cit/assets/blog_images/${item.image}`,
              id: item.id,
              customOverlay: (
                <div className="custom-overlay__caption">
                  <div>{item.title}</div>
                </div>
              ),
            }))
          );
        } else {
          console.error("No blog found with the specified id");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleBlogClick = (index, item, event) => {
    navigate("/Blog", { state: { blogId: item.id } });
  };

  return (
    <>
      <div className="blogs-banner">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="blogs-content all-blogs">
            <div className="heading">
              <div
                className="heading-flex"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <h2>Blogs</h2>
                <h4>
                  Upskill, transform and motivate your workforce, with custom
                  E-learning courses specially designed and developed for your
                  workforce.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blogs-container2">
        <div className="" data-aos="zoom-in" data-aos-duration="1500">
          <Gallery images={galleryImgs} onClick={handleBlogClick} />
        </div>
      </div>
    </>
  );
};

export default Blogs;
